export * from './admin.client';
import { AdminClient } from './admin.client';
export * from './country.client';
import { CountryClient } from './country.client';
export * from './external-permission.client';
import { ExternalPermissionClient } from './external-permission.client';
export * from './forgot-password.client';
import { ForgotPasswordClient } from './forgot-password.client';
export * from './forgot-password-direct.client';
import { ForgotPasswordDirectClient } from './forgot-password-direct.client';
export * from './permission.client';
import { PermissionClient } from './permission.client';
export * from './permission-grant.client';
import { PermissionGrantClient } from './permission-grant.client';
export * from './permission-internal.client';
import { PermissionInternalClient } from './permission-internal.client';
export * from './registration.client';
import { RegistrationClient } from './registration.client';
export * from './reset-password.client';
import { ResetPasswordClient } from './reset-password.client';
export * from './role.client';
import { RoleClient } from './role.client';
export * from './role-internal.client';
import { RoleInternalClient } from './role-internal.client';
export * from './scope.client';
import { ScopeClient } from './scope.client';
export * from './tenant.client';
import { TenantClient } from './tenant.client';
export * from './tenant-internal.client';
import { TenantInternalClient } from './tenant-internal.client';
export * from './two-factor.client';
import { TwoFactorClient } from './two-factor.client';
export * from './two-factor-internal.client';
import { TwoFactorInternalClient } from './two-factor-internal.client';
export * from './user.client';
import { UserClient } from './user.client';
export * from './user-code-internal.client';
import { UserCodeInternalClient } from './user-code-internal.client';
export * from './user-internal.client';
import { UserInternalClient } from './user-internal.client';
export * from './user-profile.client';
import { UserProfileClient } from './user-profile.client';
export * from './user-status-internal.client';
import { UserStatusInternalClient } from './user-status-internal.client';
export * from './user-type.client';
import { UserTypeClient } from './user-type.client';
export * from './user-type-internal.client';
import { UserTypeInternalClient } from './user-type-internal.client';
export const APIS = [
  AdminClient,
  CountryClient,
  ExternalPermissionClient,
  ForgotPasswordClient,
  ForgotPasswordDirectClient,
  PermissionClient,
  PermissionGrantClient,
  PermissionInternalClient,
  RegistrationClient,
  ResetPasswordClient,
  RoleClient,
  RoleInternalClient,
  ScopeClient,
  TenantClient,
  TenantInternalClient,
  TwoFactorClient,
  TwoFactorInternalClient,
  UserClient,
  UserCodeInternalClient,
  UserInternalClient,
  UserProfileClient,
  UserStatusInternalClient,
  UserTypeClient,
  UserTypeInternalClient,
];
